import React, { useEffect, useMemo, useState } from "react"
import useReportColumns from "hooks/useReportColumns"
import { REPORT_COLUMN_KEYS } from "config/reportColumnDefinitions"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import {
  exportProviderConsumptionReports,
  getProviderConsumptionReports,
} from "store/provider-reports/p-report-action"
import {
  getProviderIps,
  getProviderItemCategories,
  getProviderProjects,
} from "store/provider-dashboard/provider-dashboard-action"
import ProviderConsumptionReportListComponent from "components/ProviderReports/Consumption"
import { getProviderConsumptionsProjects } from "store/provider-consumption/province-consumption-action"

const ProviderConsumptionReportList = ({ from }) => {
  document.title = "Receipt Reports"

  const dispatch = useDispatch()

  // Retrieve consumptions data from Redux store
  const consumptions = useSelector(
    state => state.providerReports.providerConsumptionReport
  )

  // Current status of the export process for the report, retrieved from the Redux store
  const exportStatus = useSelector(
    state => state.providerReports.providerConsumptionExport
  )

  const [according, setAccording] = useState({ order: "desc", name: "date" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const { columns, visibleColumns, visibleKeys, toggleColumn, moveColumnToIndex } = useReportColumns(
    REPORT_COLUMN_KEYS.PROVIDER_CONSUMPTION
  )

  const [pageNumber, setPageNumber] = useState(20)

  // Fetches new data when a page number is clicked
  const onPageClick = link => {
    dispatch(
      getProviderConsumptionReports(
        link.url,
        pageNumber,
        according,
        advnacedSearch
      )
    )
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // fetch new data based page number or according changes
  useEffect(() => {
    dispatch(
      getProviderConsumptionReports(
        undefined,
        pageNumber,
        according,
        advnacedSearch
      )
    )
  }, [according, pageNumber])

  // fetch categores and projects
  useEffect(() => {
    dispatch(getProviderItemCategories())
    dispatch(getProviderConsumptionsProjects())
  }, [])

  // Updates search value when a new search is performed
  const onSearchHandler = data => {
    setAdvancedSearch(data)
    dispatch(
      getProviderConsumptionReports(undefined, pageNumber, undefined, data)
    )
  }

  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(exportProviderConsumptionReports(according, advnacedSearch, visibleKeys))
  }

  return (
    <React.Fragment>
      {from !== "Dashboard" && (
        <Breadcrumbs
          title={"Provider"}
          breadcrumbItem={"Consumption Reports"}
        />
      )}

      {/* Provider Consumption Report List Component */}
      <ProviderConsumptionReportListComponent
        data={consumptions?.data}
        error={consumptions?.error}
        loading={consumptions?.loading}
        onChangeOrdering={onChangeOrdering}
        onSearchHandler={onSearchHandler}
        onExportBtnClick={onExportBtnClick}
        exportStatus={exportStatus}
        from={from}
        onPageClick={onPageClick}
        onChangeRowNumber={onChangeRowNumber}
        columns={columns}
        visibleColumns={visibleColumns}
        onToggleColumn={toggleColumn}
        onReorder={moveColumnToIndex}
      />
    </React.Fragment>
  )
}

export default ProviderConsumptionReportList
